<script setup lang="ts">
import IconDocument from '~/components/icons/legal-content/IconDocument.vue'

defineOptions({
	name: 'IntroductionSection',
})

const { t: $t } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		`This Cookie Policy (hereinafter referred to as the {cookie} or {policy}) provides you with detailed information regarding the use of our services within our Platform (“Platform”) and may be supplemented by local provisions.`,
		{
			cookie: `<span class="font-semibold">“${$t('Cookie Policy')}”</span>`,
			policy: `<span class="font-semibold">“${$t('Policy')}”</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<IconDocument class="text-[#ED8B00] size-7" />
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Introduction') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p>
				{{
					$tThird(
						'This Policy does not apply to third-party websites that may be accessed via links provided in our Platform',
					)
				}}.
			</p>
			<p>
				{{
					$t(
						'The Platform employs cookies and/or similar technologies that collect and store information as you navigate through it',
					)
				}}.
			</p>
		</div>
	</section>
</template>
